import React from "react";

import FeatureFlagWrapper from "@stadium/services/launch-darkly/feature-flag-wrapper";
import { hideCreateNewWorkspaceFlag } from "@stadium/services/launch-darkly/constants";

import Modal from "@stadium/ui/src/components/ModalNew";
import {
  CloseButton,
  ModalBody,
  ModalContent,
  ModalDialog,
  ModalFooter,
  ModalHeader,
} from "@stadium/ui/src/components/ModalNew/utils";
import { LinkButton } from "@stadium/shared/src/components/shared/button";
import { CONTACT_US, CREATE_NEW_WORKSPACE_ROUTE } from "@stadium/constants/routes";
import Portal from "@stadium/ui/src/components/portal";
import styles from "./main.module.scss";

const CreateWorkspaceModal = ({ closeModal }) => {
  return (
    <Portal id="modal-root" dataContainerId="create-workspace-modal">
      <Modal closeModal={closeModal} mobileBottomDrawer newModal className={styles.createWorkspaceModal}>
        <ModalDialog className={styles.modalDialog}>
          <ModalContent>
            <ModalHeader className={styles.modalHeader}>
              <span id="create-workspace-modal-title">Create a new Workspace?</span>
              <CloseButton onClick={closeModal} autoFocus />
            </ModalHeader>
            <ModalBody className={styles.modalBody} tabIndex="0" aria-labelledby="create-workspace-modal-title create-workspace-modal-info-panel">
              <div className={styles.infoPanel} id="create-workspace-modal-info-panel">
                <p className={styles.heading}>
                  None of your data will carry over from your existing Workspaces.
                </p>
                <div className={styles.infoChecklist}>
                  <p className={styles.checklistTitle}>You'll need to:</p>
                  <ol className={styles.checklist}>
                    <li className={styles.listItem}>Start from scratch with all contacts and assets.</li>
                    <li className={styles.listItem}>Manage billing and subscriptions separately.</li>
                  </ol>
                </div>
              </div>
              <div className={styles.contentPanel}>
              <p className={styles.heading}>Most teams don't need more than one Workspace.</p>
                <p className={styles.text}>
                  We recommend organizing your team, roles, and permissions in your existing Workspace
                  instead. If you don't have the right permissions, reach out to an admin or contact
                  us.
                </p>
              </div>
            </ModalBody>
            <ModalFooter className={styles.modalFooter}>
              <LinkButton
                styleType="primary-outline"
                href={CONTACT_US}
                className={styles.secondaryCta}
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Contact us (opens in a new tab)"
              >
                Contact us{" "}
                <span className={styles.iconExternalLink} />
              </LinkButton>
              <FeatureFlagWrapper flag={hideCreateNewWorkspaceFlag} fallback={(
                <LinkButton styleType="primary" href={CREATE_NEW_WORKSPACE_ROUTE} className={styles.primaryCta}>
                  Create new workspace
                </LinkButton>
              )}>
              </FeatureFlagWrapper>
            </ModalFooter>
          </ModalContent>
        </ModalDialog>
      </Modal>
    </Portal>
  );
};

export default CreateWorkspaceModal;
